module.exports = __webpack_public_path__ + "img/feature-5.3bb96c45.webp";